import React from 'react';
import { Grid, Typography, Button } from '@mui/material';
import Scales from '@Components/Utils/icons/Scales';
import { useGlobalization } from '@Translations/useGlobalization';

interface NoCategoriesProps {
	section: 'lof' | 'cof';
	handleAddCategoryClicked: () => void;
}

// Shared empty state for LoF/CoF Setup — identical markup, only the
// heading/caption text differs per section. Extracted so NoLoFCategories
// and NoCoFCategories don't duplicate this structure (flagged by
// SonarQube's CPD, which treats differing string literals in otherwise
// identical JSX as a duplicate block).
export const NoCategories: React.FC<NoCategoriesProps> = ({
	section,
	handleAddCategoryClicked,
}) => {
	const { t } = useGlobalization();
	const heading =
		section === 'lof' ? t('No LoF Categories') : t('No CoF Categories');
	const caption =
		section === 'lof'
			? t('You have no LoF categories created.')
			: t('You have no CoF categories created.');

	return (
		<Grid container>
			<Grid
				container
				item
				xs={12}
				justifyContent="center"
				style={{ paddingTop: '40px' }}>
				<Scales />
			</Grid>
			<Grid container item xs={12} justifyContent="center">
				<Typography variant="h6">{heading}</Typography>
			</Grid>
			<Grid container item xs={12} justifyContent="center">
				<Typography variant="caption" style={{ textAlign: 'center' }}>
					{caption}
				</Typography>
			</Grid>
			<Grid
				container
				item
				xs={12}
				justifyContent="center"
				style={{
					paddingTop: '20px',
					paddingBottom: '20px',
				}}>
				<Button
					variant="contained"
					color="primary"
					onClick={handleAddCategoryClicked}>
					{t('Add Category')}
				</Button>
			</Grid>
		</Grid>
	);
};
